<template>
  <el-button
    type="text"
    class="copy-btn"
    data-clipboard-action="copy"
    :data-clipboard-target="id"
    @click="handleCopyToClipboard"
  >{{ text }}</el-button>
</template>

<script>
import Clipboard from "clipboard";

export default {
  name: "copy-btn",
  props: {
    id: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '复制',
    },
  },
  methods: {
    handleCopyToClipboard() {
      const clipboard = new Clipboard('.copy-btn');
      clipboard.on("success", () => {
        clipboard.destroy();
      });
      clipboard.on("error", () => {
        this.$message.warning("该项不支持自动复制");
        clipboard.destroy();
      });
    },
  },
};
</script>

<style scoped>

</style>
